import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentation,
    SimplePresentationRunner
} from "../../core/winpresentation/SimplePresentationRunner";
import {TheCryptInitialWinPresentation} from "../presentations/TheCryptInitialWinPresentation";
import {CollapsePresentation} from "../presentations/maingame/CollapsePresentation";
import {TheCryptNudgePresentation} from "../presentations/maingame/TheCryptNudgePresentation";
import {WinCountUpPresentation} from "../presentations/WinCountUpPresentation";
import {TheCryptBigWinPresentation} from "../presentations/TheCryptBigWinPresentation";
import {
    TheCryptRoundEndPresentation
} from "../presentations/TheCryptRoundEndPresentation";
import {TheCryptXWayExpandPresentation} from "../presentations/maingame/TheCryptXWayExpandPresentation";
import {WinCapPresentation} from "../presentations/WinCapPresentation";

export class TheCryptWinPresentation implements FlowStatePresentation {
    private presentations: SimplePresentation[];

    constructor() {
        this.presentations = [
            new TheCryptXWayExpandPresentation(),
            new TheCryptNudgePresentation(),
            new TheCryptInitialWinPresentation(),
            new CollapsePresentation(),
            new WinCountUpPresentation(),
            new TheCryptRoundEndPresentation(),
            new TheCryptBigWinPresentation(),
            new WinCapPresentation()
        ];
    }

    public start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }
}